import { WORK_FUNCTION_SHORT_LABELS, WORK_LOCATION_SHORT_LABELS } from './workShortLabels.js';

function label(table, name) {
  return name != null && Object.hasOwn(table, name) ? table[name] : null;
}

export function accountSubtitle(user) {
  return (
    label(WORK_FUNCTION_SHORT_LABELS, user.work_function) ??
    label(WORK_LOCATION_SHORT_LABELS, user.work_location) ??
    user.email
  );
}
